import { useEffect, useMemo, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renderiza o conteúdo de impressão **fora do #root** (direto no body),
 * para que durante `@media print` consigamos esconder o app inteiro
 * (`#root { display: none }`) sem esconder também o que tem que sair na
 * folha. Isso mantém o modal de pré-visualização aberto enquanto o print
 * roda, e evita o problema de o body ter altura do app e gerar páginas
 * em branco extras.
 */
export function PrintPortal({ children }: { children: ReactNode }) {
  const container = useMemo(() => {
    const el = document.createElement('div');
    el.className = 'print-portal';
    return el;
  }, []);

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      if (container.parentNode) container.parentNode.removeChild(container);
    };
  }, [container]);

  return createPortal(children, container);
}
